export default "__VITE_ASSET__B1$g15$V__"